var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphicaldesigning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.221,
    height: 44.008,
    viewBox: "0 0 44.221 44.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphical_designing",
    "data-name": "graphical designing",
    transform: "translate(-2.667 -1.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M12,23.213V36H24.787L22.12,33.333H14.667V25.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M46.493,43.053l-3.827-3.88v3.493H5.333V37.133H8V35H5.333V26.133H8V24H5.333V15.467H8V13.333H5.333V5.88L26.587,27.013v-3.76L4.947,1.72a1.333,1.333,0,0,0-2.28.947V44A1.333,1.333,0,0,0,4,45.333H45.547a1.333,1.333,0,0,0,.947-2.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M32,40h5.333A2.667,2.667,0,0,0,40,37.333V11.6L36.933,5.96a2.68,2.68,0,0,0-4.693.107l-2.907,5.56V37.333A2.667,2.667,0,0,0,32,40Zm0-27.733L34.587,7.24l2.747,5.04V32H32Zm0,21.907h5.333v3.253H32Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicaldesigning);
export default __webpack_public_path__ + "static/media/graphicaldesigning.785b035a014943a975862a0906e1d4b7.svg";
export { ForwardRef as ReactComponent };